var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLastPage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7E8A93",
  d: "M2.777 5.77a1 1 0 0 0 0 1.46l3.539 3.32c.638.598 1.684.145 1.684-.73V3.18c0-.875-1.046-1.328-1.684-.729l-3.539 3.32Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7E8A93",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M1 3v7"
})));
export default SvgLastPage;